import React from "react";
import LayersIcon from '@mui/icons-material/Layers';
import ScienceIcon from '@mui/icons-material/Science';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddIcon from '@mui/icons-material/Add';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

const EnvasadoTerminadoSection = ({
  terminadoRecords,
  isFormOpen,
  setIsFormOpen,
  fechaMovimiento,
  setFechaMovimiento,
  botCaja,
  setBotCaja,
  marca,
  setMarca,
  noLoteGranel,
  setNoLoteGranel,
  loteEnvasado,
  setLoteEnvasado,
  categoria,
  setCategoria,
  claseEtiqueta,
  setClaseEtiqueta,
  ingredientesEtiqueta,
  setIngredientesEtiqueta,
  edad,
  setEdad,
  tipoMagueyEtiqueta,
  setTipoMagueyEtiqueta,
  noAnalisis,
  setNoAnalisis,
  capacidad,
  setCapacidad,
  pctAlcEtiqueta,
  setPctAlcEtiqueta,
  noInformeAprobacion,
  setNoInformeAprobacion,
  fechaAprobacionEtiqueta,
  setFechaAprobacionEtiqueta,
  invInicialCajas,
  setInvInicialCajas,
  invInicialBotellas,
  setInvInicialBotellas,
  entradaProcedencia,
  setEntradaProcedencia,
  entradaCajas,
  setEntradaCajas,
  entradaBotellas,
  setEntradaBotellas,
  salidaCajas,
  setSalidaCajas,
  salidaBotellas,
  setSalidaBotellas,
  salidaDestino,
  setSalidaDestino,
  invFinalCajas,
  setInvFinalCajas,
  invFinalBotellas,
  setInvFinalBotellas,
  observaciones,
  setObservaciones,
  handleSaveTerminado
}) => {
  if (!isFormOpen) {
    return (
      <div className="animate-fadeIn">
        <div className="history-section-header">
          <h2>Inventarios de Mezcal Envasado "Terminado" (Sección IV)</h2>
          <button 
            onClick={() => setIsFormOpen(true)}
            className="btn-add-new"
          >
            <AddIcon style={{ fontSize: 18 }} />
            <span>Nuevo Registro Terminado</span>
          </button>
        </div>

        <div className="records-list-wrapper">
          <table className="records-table">
            <thead>
              <tr>
                <th colSpan="15" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Datos Generales / Identificación de Etiqueta</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Inventario Inicial</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Entradas</th>
                <th colSpan="3" style={{ textAlign: "center", background: "rgba(210, 105, 30, 0.2)", color: "var(--copper)" }}>Salidas</th>
                <th colSpan="2" style={{ textAlign: "center", background: "rgba(74, 93, 35, 0.2)", color: "var(--agave-green)" }}>Inventario Final</th>
                <th colSpan="3" style={{ textAlign: "center" }}>Finalización</th>
              </tr>
              <tr>
                {/* Identificación */}
                <th>Fecha Mov.</th>
                <th>Bot/Caja</th>
                <th>Marca</th>
                <th>Lote Granel</th>
                <th>Lote Env.</th>
                <th>Categoría</th>
                <th>Clase Etiqueta</th>
                <th>Ingrediente(s)</th>
                <th>Edad</th>
                <th>Tipo Maguey</th>
                <th>Nº Análisis</th>
                <th>Capacidad</th>
                <th>% Alc. Vol. Etiqueta</th>
                <th>Informe Aprobación</th>
                <th>Fecha Aprob.</th>

                {/* Inv Inicial */}
                <th>Cajas</th>
                <th>Botellas</th>

                {/* Entradas */}
                <th>Procedencia</th>
                <th>Cajas</th>
                <th>Botellas</th>

                {/* Salidas */}
                <th>Cajas</th>
                <th>Botellas</th>
                <th>Destino</th>

                {/* Inv Final */}
                <th>Cajas</th>
                <th>Botellas</th>

                {/* Cierre */}
                <th>Observaciones</th>
                <th>V.Bo. Inspector</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              {terminadoRecords.map((rec, i) => (
                <tr key={i}>
                  <td>{rec.fechaMovimiento}</td>
                  <td>{rec.botCaja}</td>
                  <td style={{ fontWeight: 800 }}>{rec.marca}</td>
                  <td>{rec.noLoteGranel}</td>
                  <td style={{ color: "var(--copper)", fontWeight: 700 }}>{rec.loteEnvasado}</td>
                  <td>{rec.categoria}</td>
                  <td>{rec.claseEtiqueta}</td>
                  <td>{rec.ingredientesEtiqueta}</td>
                  <td>{rec.edad}</td>
                  <td>{rec.tipoMagueyEtiqueta}</td>
                  <td>{rec.noAnalisis}</td>
                  <td>{rec.capacidad}</td>
                  <td>{rec.pctAlcEtiqueta}%</td>
                  <td style={{ color: "var(--agave-green)", fontWeight: 700 }}>{rec.noInformeAprobacion}</td>
                  <td>{rec.fechaAprobacionEtiqueta}</td>

                  <td>{rec.invInicialCajas}</td>
                  <td>{rec.invInicialBotellas}</td>

                  <td>{rec.entradaProcedencia}</td>
                  <td>{rec.entradaCajas}</td>
                  <td>{rec.entradaBotellas}</td>

                  <td>{rec.salidaCajas}</td>
                  <td>{rec.salidaBotellas}</td>
                  <td>{rec.salidaDestino}</td>

                  <td style={{ color: "var(--agave-green)", fontWeight: 700 }}>{rec.invFinalCajas}</td>
                  <td style={{ color: "var(--agave-green)", fontWeight: 700 }}>{rec.invFinalBotellas}</td>

                  <td style={{ maxWidth: "150px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {rec.observaciones}
                  </td>
                  <td style={{ fontSize: "11px" }}>{rec.inspector}</td>
                  <td>
                    <span className={`badge-status ${rec.status}`}>
                      {rec.status === "aprobado" ? "Aprobado" : rec.status === "revision" ? "En revisión" : "Borrador"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-fadeIn">
      <div className="history-section-header">
        <button onClick={() => setIsFormOpen(false)} className="btn-secondary-custom" style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 16px" }}>
          <ArrowBackIcon style={{ fontSize: 16 }} />
          <span>Volver al Historial</span>
        </button>
        <h2>Nuevo Registro de Envasado Terminado - Sección IV</h2>
      </div>

      <div className="cards-container-grid">
        {/* IDENTIFICACIÓN */}
        <section className="detail-card detail-card-accent-left-green">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <LayersIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Identificación del Mezcal y Lote</h2>
              <p>Datos del envasado e ingrediente en etiqueta</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="date" 
                value={fechaMovimiento} 
                onChange={e => setFechaMovimiento(e.target.value)} 
                className="custom-input-field"
              />
              <label className="custom-input-label">Fecha del Movimiento</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={botCaja} 
                onChange={e => setBotCaja(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. 12 botellas"
              />
              <label className="custom-input-label">Botellas por Caja (Bot/Caja)</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={marca} 
                onChange={e => setMarca(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Don Julio Mezcal"
              />
              <label className="custom-input-label">Marca Comercial</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={noLoteGranel} 
                onChange={e => setNoLoteGranel(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. L-01-GRANEL"
              />
              <label className="custom-input-label">Nº Lote a Granel</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={loteEnvasado} 
                onChange={e => setLoteEnvasado(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. L-01-ENV-T"
              />
              <label className="custom-input-label">Lote de Envasado</label>
            </div>

            <div className="custom-input-group">
              <select 
                value={categoria} 
                onChange={e => setCategoria(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Mezcal">Mezcal</option>
                <option value="Mezcal Artesanal">Mezcal Artesanal</option>
                <option value="Mezcal Ancestral">Mezcal Ancestral</option>
              </select>
              <label className="custom-input-label">Categoría</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <select 
                value={claseEtiqueta} 
                onChange={e => setClaseEtiqueta(e.target.value)}
                className="custom-select-field"
                style={{ padding: "18px 16px 8px 16px" }}
              >
                <option value="Joven / Blanco">Joven / Blanco</option>
                <option value="Madurado en Vidrio">Madurado en Vidrio</option>
                <option value="Reposado">Reposado</option>
                <option value="Añejo">Añejo</option>
                <option value="Abocado con">Abocado con</option>
                <option value="Destilado con">Destilado con</option>
              </select>
              <label className="custom-input-label">Clase en Etiqueta</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={ingredientesEtiqueta} 
                onChange={e => setIngredientesEtiqueta(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Maguey Espadín"
              />
              <label className="custom-input-label">Ingrediente(s) en Etiqueta</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={edad} 
                onChange={e => setEdad(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Reposado 6 meses"
              />
              <label className="custom-input-label">Edad (Meses o Años)</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={tipoMagueyEtiqueta} 
                onChange={e => setTipoMagueyEtiqueta(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. Espadín"
              />
              <label className="custom-input-label">Tipo de Maguey(es) en Etiqueta</label>
            </div>
          </div>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="text" 
                value={noAnalisis} 
                onChange={e => setNoAnalisis(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. ANA-2026-98"
              />
              <label className="custom-input-label">Nº de Análisis Fisicoquímico</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="text" 
                value={capacidad} 
                onChange={e => setCapacidad(e.target.value)} 
                className="custom-input-field"
                placeholder="Ej. 750 ml"
              />
              <label className="custom-input-label">Capacidad</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 12 }}>
            <input 
              type="number" 
              step="0.1"
              value={pctAlcEtiqueta} 
              onChange={e => setPctAlcEtiqueta(e.target.value)} 
              className="custom-input-field"
            />
            <label className="custom-input-label">% Alc. Vol. en Etiqueta</label>
            <span className="input-suffix">%</span>
          </div>
        </section>

        {/* CERTIFICACIÓN & APROBACIÓN DE ETIQUETA */}
        <section className="detail-card detail-card-accent-left-copper">
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-copper">
              <WorkspacePremiumIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Aprobación de Etiqueta</h2>
              <p>Datos oficiales de registro del informe de etiquetado</p>
            </div>
          </header>

          <div className="custom-input-group">
            <input 
              type="text" 
              value={noInformeAprobacion} 
              onChange={e => setNoInformeAprobacion(e.target.value)} 
              className="custom-input-field" 
              placeholder="Ej. INF-APR-ET-102"
            />
            <label className="custom-input-label">Nº Informe de Aprobación de Etiqueta</label>
          </div>

          <div className="custom-input-group" style={{ marginTop: 16 }}>
            <input 
              type="date" 
              value={fechaAprobacionEtiqueta} 
              onChange={e => setFechaAprobacionEtiqueta(e.target.value)} 
              className="custom-input-field" 
            />
            <label className="custom-input-label">Fecha de Aprobación</label>
          </div>

          <hr style={{ border: 0, borderBottom: "1px solid var(--glass-border)", margin: "24px 0 16px 0" }} />

          <header className="detail-card-header" style={{ padding: 0, marginBottom: 12 }}>
            <div className="detail-card-icon-wrapper-green">
              <ShoppingBagIcon style={{ fontSize: 18 }} />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Inventario Inicial</h2>
              <p>Saldos de inicio del periodo en cajas y botellas</p>
            </div>
          </header>

          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={invInicialCajas} 
                onChange={e => setInvInicialCajas(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Cajas Iniciales</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={invInicialBotellas} 
                onChange={e => setInvInicialBotellas(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Botellas Iniciales</label>
            </div>
          </div>
        </section>

        {/* ENTRADAS, SALIDAS E INVENTARIO FINAL */}
        <section className="detail-card detail-card-accent-left-green" style={{ gridColumn: "1 / -1" }}>
          <header className="detail-card-header">
            <div className="detail-card-icon-wrapper-green">
              <CheckCircleIcon />
            </div>
            <div className="detail-card-title-wrapper">
              <h2>Entradas, Salidas y Saldos de Cierre</h2>
              <p>Flujo físico de producto terminado en almacén</p>
            </div>
          </header>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", marginTop: "12px" }}>
            {/* Column 1: Entradas */}
            <div>
              <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", borderBottom: "1px solid var(--glass-border)", paddingBottom: "6px", marginBottom: "16px" }}>
                ENTRADAS
              </h3>

              <div className="custom-input-group" style={{ marginBottom: 12 }}>
                <input 
                  type="text" 
                  value={entradaProcedencia} 
                  onChange={e => setEntradaProcedencia(e.target.value)} 
                  className="custom-input-field" 
                  placeholder="Ej. Etiquetado de lote NT-01"
                />
                <label className="custom-input-label">Procedencia de Entrada</label>
              </div>

              <div className="species-grid">
                <div className="custom-input-group">
                  <input 
                    type="number" 
                    value={entradaCajas} 
                    onChange={e => setEntradaCajas(e.target.value)} 
                    className="custom-input-field" 
                  />
                  <label className="custom-input-label">Cajas Entrada</label>
                </div>

                <div className="custom-input-group">
                  <input 
                    type="number" 
                    value={entradaBotellas} 
                    onChange={e => setEntradaBotellas(e.target.value)} 
                    className="custom-input-field" 
                  />
                  <label className="custom-input-label">Botellas Entrada</label>
                </div>
              </div>
            </div>

            {/* Column 2: Salidas */}
            <div>
              <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--copper)", borderBottom: "1px solid var(--glass-border)", paddingBottom: "6px", marginBottom: "16px" }}>
                SALIDAS
              </h3>

              <div className="custom-input-group" style={{ marginBottom: 12 }}>
                <input 
                  type="text" 
                  value={salidaDestino} 
                  onChange={e => setSalidaDestino(e.target.value)} 
                  className="custom-input-field" 
                  placeholder="Ej. Despacho a Cliente Nacional"
                />
                <label className="custom-input-label">Destino de Salida</label>
              </div>

              <div className="species-grid">
                <div className="custom-input-group">
                  <input 
                    type="number" 
                    value={salidaCajas} 
                    onChange={e => setSalidaCajas(e.target.value)} 
                    className="custom-input-field" 
                  />
                  <label className="custom-input-label">Cajas Salida</label>
                </div>

                <div className="custom-input-group">
                  <input 
                    type="number" 
                    value={salidaBotellas} 
                    onChange={e => setSalidaBotellas(e.target.value)} 
                    className="custom-input-field" 
                  />
                  <label className="custom-input-label">Botellas Salida</label>
                </div>
              </div>
            </div>
          </div>

          <h3 style={{ fontSize: "14px", fontWeight: 700, color: "var(--agave-green)", borderBottom: "1px solid var(--glass-border)", paddingBottom: "6px", marginTop: "24px", marginBottom: "16px" }}>
            INVENTARIO FINAL CALCULADO
          </h3>
          <div className="species-grid">
            <div className="custom-input-group">
              <input 
                type="number" 
                value={invFinalCajas} 
                onChange={e => setInvFinalCajas(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Nº Cajas Finales</label>
            </div>

            <div className="custom-input-group">
              <input 
                type="number" 
                value={invFinalBotellas} 
                onChange={e => setInvFinalBotellas(e.target.value)} 
                className="custom-input-field" 
              />
              <label className="custom-input-label">Nº Botellas Finales</label>
            </div>
          </div>

          <div className="custom-input-group" style={{ marginTop: 20 }}>
            <textarea 
              value={observaciones} 
              onChange={e => setObservaciones(e.target.value)} 
              className="custom-input-field"
              style={{ height: "80px", resize: "none", padding: "14px" }}
              placeholder="Notas generales sobre el lote de terminado..."
            />
            <label className="custom-input-label">Observaciones</label>
          </div>
        </section>
      </div>

      <div className="button-row">
        <button type="button" className="btn-secondary-custom" onClick={() => setIsFormOpen(false)}>Volver</button>
        <button 
          type="button" 
          className="btn-primary-custom" 
          onClick={() => handleSaveTerminado("revision")}
        >
          <CheckCircleIcon style={{ fontSize: 16 }} />
          <span>Registrar Sección IV</span>
        </button>
      </div>
    </div>
  );
};

export default EnvasadoTerminadoSection;
